import React from 'react';
import Carousel from "../components/Carousel";
import {useTeam} from "../contexts/TeamContext";
import {useUser} from "../contexts/UserContext";

function Fixtures(props) {

    const { team } = useTeam();
    const { user } = useUser();

    return (
        <div className="fixtures p-2">
            <h1 className="title">Fixtures</h1>
            {team.fixtures.length > 0 ? (
                <Carousel/>
            ) : (
                <div className="d-flex align-items-center flex-column">
                    <h6>{team.teamName} does not have any fixtures</h6>
                    {user?.isAdmin && (
                        <div>
                            <button type={'button'} className={"btn btn-outline-secondary"} style={{backgroundColor: team?.theme?.secondaryColor}}>Go to admin panel</button>
                        </div>
                    )}
                </div>
            )}

        </div>
    );
}

export default Fixtures;